/* eslint-disable jsx-a11y/media-has-caption */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useEffect, useState } from 'react';

import yellow from '../../../video/JAUNE.mov.mp4';
import videomp4 from '../../../video/_Intro.mov.mp4';
import videoloopmp4 from '../../../video/_Intro_LOOP.mov.mp4';
import mobilevideomp4 from '../../../video/_Mobile_Intro.mov.mp4';
import mobilevideoloopmp4 from '../../../video/_Mobile_LOOP.mov.mp4';
import { useWindowSize } from '../../contexts/SiteContext';

import styles from '../../../styles/slides/home-video.module.scss';

import posterpng from '../../../video/_Intro_LOOP.mov.png';
import posterpngmob from '../../../video/_Mobile_LOOP.mov.png';

const propTypes = {
    item: PropTypes.shape({
        description: PropTypes.string,
    }),
    duration: PropTypes.number,
    className: PropTypes.string,
    isDragging: PropTypes.bool,
    isCurrent: PropTypes.bool,
};

const defaultProps = {
    item: null,
    duration: 5000,
    className: null,
    isDragging: false,
    isCurrent: false,
};

const HomeVideo = ({ duration, className, isDragging, isCurrent }) => {
    const ref = useRef(null);
    const loopRef = useRef(null);
    const { width, height } = useWindowSize();
    const widescreen = width > height;

    useEffect(() => {
        const { current: video = null } = loopRef;
        if (isCurrent && video !== null) {
            video.currentTime = 0;
            video.play();
        }
    }, [isCurrent]);

    const [looping, setLooping] = useState(null);
    useEffect(() => {
        const id = setTimeout(() => {
            setLooping(true);
        }, duration);
        return () => {
            clearTimeout(id);
            setLooping(false);
        };
    }, [setLooping, duration]);

    const [showPoster, setShowPoster] = useState(false);
    useEffect(() => {
        const id = setTimeout(() => {
            setShowPoster(true);
        }, 1400);
        return () => {
            clearTimeout(id);
            setShowPoster(false);
        };
    }, [setShowPoster]);

    useEffect(() => {
        const { current: video = null } = ref;
        if (video !== null) {
            video.addEventListener('ended', () => {
                setLooping(true);
            });
        }
        return () => {
            if (video !== null) {
                video.removeEventListener('ended', () => {
                    setLooping(false);
                });
            }
        };
    }, [setLooping]);

    const poster = widescreen ? posterpng : posterpngmob;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isCurrent]: isCurrent,
                    [styles.isDragging]: isDragging,
                    [styles.looping]: looping,
                    [styles.widescreen]: widescreen,
                },
            ])}
        >
            <div className={styles.videoContainer}>
                <video
                    className={classNames([styles.video, styles.background])}
                    muted
                    autoPlay
                    disablePictureInPicture
                    playsInline
                    loop
                >
                    <source src={`${yellow}#t=0.0`} type="video/mp4" />
                </video>
                <video
                    ref={ref}
                    className={classNames([styles.video, styles.main])}
                    poster={showPoster ? poster : null}
                    muted
                    autoPlay
                    disablePictureInPicture
                    playsInline
                >
                    <source
                        src={`${widescreen ? videomp4 : mobilevideomp4}#t=0.0`}
                        type="video/mp4"
                    />
                </video>
                <video
                    ref={loopRef}
                    className={classNames([styles.video, styles.loop])}
                    poster={showPoster ? poster : null}
                    muted
                    autoPlay
                    disablePictureInPicture
                    playsInline
                    loop
                >
                    <source
                        src={`${widescreen ? videoloopmp4 : mobilevideoloopmp4}#t=0.0`}
                        type="video/mp4"
                    />
                </video>
            </div>
        </div>
    );
};

HomeVideo.propTypes = propTypes;
HomeVideo.defaultProps = defaultProps;

export default HomeVideo;
